import { render, staticRenderFns } from "./DefaultPayment.vue?vue&type=template&id=0bb96ab9"
import script from "./DefaultPayment.vue?vue&type=script&lang=js"
export * from "./DefaultPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports